import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa', icon: 'ri-home-4-line' },
    { path: '/hakkimizda', label: 'Hakkımızda', icon: 'ri-information-line' },
    { path: '/hizmetler', label: 'Hizmetler', icon: 'ri-tools-line' },
    { path: '/urunler', label: 'Ürünler', icon: 'ri-computer-line' },
    { path: '/teknik-servis', label: 'Teknik Servis', icon: 'ri-customer-service-2-line' },
    { path: '/blog', label: 'Blog', icon: 'ri-article-line' },
    { path: '/iletisim', label: 'İletişim', icon: 'ri-map-pin-line' },
  ];

  // Mobil tab bar için 5 ana link
  const mobileTabLinks = [
    { path: '/', label: 'Ana Sayfa', icon: 'ri-home-4-line' },
    { path: '/hizmetler', label: 'Hizmetler', icon: 'ri-tools-line' },
    { path: '/urunler', label: 'Ürünler', icon: 'ri-computer-line' },
    { path: '/teknik-servis', label: 'Servis', icon: 'ri-customer-service-2-line' },
    { path: '/iletisim', label: 'İletişim', icon: 'ri-map-pin-line' },
  ];

  return (
    <>
      {/* ===================== DESKTOP HEADER ===================== */}
      <header className="hidden lg:block fixed top-0 left-0 right-0 z-50">
        {/* Üst bilgi çubuğu */}
        <div
          className={`transition-all duration-300 overflow-hidden ${
            isScrolled ? 'max-h-0 opacity-0' : 'max-h-12 opacity-100'
          }`}
          style={{ background: '#0f1419' }}
        >
          <div className="max-w-[1400px] mx-auto px-8 h-10 flex items-center justify-between">
            <div className="flex items-center gap-6 text-xs text-neutral-400">
              <span className="flex items-center gap-1.5">
                <i className="ri-map-pin-2-line text-secondary"></i>
                Anafartalar Cad. Ulus Şehir Çarşısı No:3/11 Altındağ / ANKARA
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-secondary"></i>
                Pzt–Cmt: 09:00–19:00
              </span>
            </div>
            <div className="flex items-center gap-5 text-xs text-neutral-400">
              <a href="mailto:info@esbilgisayar.com.tr" className="flex items-center gap-1.5 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line text-secondary"></i>
                info@esbilgisayar.com.tr
              </a>
              <a href="tel:+905065376985" className="flex items-center gap-1.5 hover:text-white transition-colors cursor-pointer">
                <i className="ri-phone-line text-secondary"></i>
                0506 537 69 85
              </a>
              <div className="flex items-center gap-3 ml-2 pl-4 border-l border-neutral-700">
                <a href="#" className="w-6 h-6 flex items-center justify-center text-neutral-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" className="w-6 h-6 flex items-center justify-center text-neutral-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-line text-sm"></i>
                </a>
                <a href="#" className="w-6 h-6 flex items-center justify-center text-neutral-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Ana navigasyon */}
        <div
          className={`transition-all duration-300 ${
            isScrolled
              ? 'bg-white/95 backdrop-blur-md shadow-lg'
              : 'bg-primary/80 backdrop-blur-sm'
          }`}
        >
          <div className="max-w-[1400px] mx-auto px-8">
            <div className="flex items-center justify-between h-[72px]">
              {/* Logo */}
              <Link to="/" className="flex items-center gap-3 flex-shrink-0">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary shadow-md">
                  <i className="ri-computer-line text-white text-xl"></i>
                </div>
                <div className="flex flex-col leading-tight">
                  <span className={`font-heading font-bold text-lg tracking-tight transition-colors ${isScrolled ? 'text-primary' : 'text-white'}`}>
                    Es Donanım Bilgisayar
                  </span>
                  <span className={`text-[10px] font-medium tracking-widest uppercase transition-colors ${isScrolled ? 'text-secondary' : 'text-secondary-light'}`}>
                    Teknik Servis &amp; Alım Satım
                  </span>
                </div>
              </Link>

              {/* Nav linkleri */}
              <nav className="flex items-center gap-0.5">
                {navLinks.map((link) => {
                  const isActive = location.pathname === link.path;
                  return (
                    <Link
                      key={link.path}
                      to={link.path}
                      className={`relative px-3.5 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer group ${
                        isActive
                          ? 'text-secondary'
                          : isScrolled
                          ? 'text-neutral-700 hover:text-secondary'
                          : 'text-white/90 hover:text-white'
                      }`}
                    >
                      {link.label}
                      <span
                        className={`absolute bottom-1 left-3.5 right-3.5 h-0.5 rounded-full bg-secondary transition-all duration-200 ${
                          isActive ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0 group-hover:opacity-60 group-hover:scale-x-100'
                        }`}
                      />
                    </Link>
                  );
                })}
              </nav>

              {/* CTA butonları */}
              <div className="flex items-center gap-2.5 flex-shrink-0">
                <a
                  href="tel:+905065376985"
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-secondary text-white text-sm font-semibold hover:bg-secondary-dark transition-all shadow-sm hover:shadow-md whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-fill text-base"></i>
                  <span>Hemen Ara</span>
                </a>
                <a
                  href="https://wa.me/905065376985"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-whatsapp text-white text-sm font-semibold hover:bg-whatsapp/90 transition-all shadow-sm hover:shadow-md whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ===================== MOBİL HEADER (sadece üst logo çubuğu) ===================== */}
      <header className="lg:hidden fixed top-0 left-0 right-0 z-50">
        <div
          className={`transition-all duration-300 ${
            isScrolled
              ? 'bg-white/95 backdrop-blur-md shadow-md'
              : 'bg-primary/90 backdrop-blur-sm'
          }`}
        >
          <div className="px-4 h-16 flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-secondary shadow">
                <i className="ri-computer-line text-white text-lg"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className={`font-heading font-bold text-base tracking-tight transition-colors ${isScrolled ? 'text-primary' : 'text-white'}`}>
                  Es Donanım Bilgisayar
                </span>
                <span className={`text-[9px] font-medium tracking-widest uppercase transition-colors ${isScrolled ? 'text-secondary' : 'text-secondary-light'}`}>
                  Teknik Servis
                </span>
              </div>
            </Link>

            {/* Sağ: Ara ve WhatsApp butonları */}
            <div className="flex items-center gap-2">
              <a
                href="tel:+905065376985"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-secondary text-white shadow cursor-pointer"
                aria-label="Ara"
              >
                <i className="ri-phone-fill text-base"></i>
              </a>
              <a
                href="https://wa.me/905065376985"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-whatsapp text-white shadow cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* ===================== MOBİL ALT TAB BAR ===================== */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-neutral-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
        <div className="flex items-stretch h-16">
          {mobileTabLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className="flex-1 flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-all"
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-xl transition-all ${
                    isActive ? 'bg-secondary/10' : ''
                  }`}
                >
                  <i
                    className={`${link.icon} text-xl transition-colors ${
                      isActive ? 'text-secondary' : 'text-neutral-400'
                    }`}
                  ></i>
                </div>
                <span
                  className={`text-[10px] font-medium transition-colors leading-none ${
                    isActive ? 'text-secondary' : 'text-neutral-400'
                  }`}
                >
                  {link.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
